<template>
  <v-form ref="form3">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Bezigheden</span>

      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary"
            >Hoeveel uur slaap je per nacht?</span
          >
          <v-text-field
            v-model="localQuestions['Hoeveel uur slaap je per nacht?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
            type="number"
            hide-spin-buttons
          >
            <template v-slot:append-inner>
              <span class="text-normal text-secondary">uur</span>
            </template>
          </v-text-field>
        </div>
        <div class="d-flex flex-column ga-4">
          <label for="category" class="text-normal text-primary"
            >Welke categorie sluit het beste aan bij jouw huidige
            levensfase?</label
          >
          <v-select
            name="category"
            color="secondary"
            v-model="
              localQuestions[
                'Welke categorie sluit het beste aan bij jouw huidige levensfase?'
              ]
            "
            :menu-props="{ maxHeight: '360px' }"
            :items="categories"
            :rules="[rules.select_rules.required]"
            base-color="secondary"
            content-class="custom-dropdown-height"
            variant="underlined"
          >
          </v-select>
        </div>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary">Wat voor werk doe je?</span>
          <v-text-field
            v-model="localQuestions['Wat voor werk doe je?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
            placeholder="Kantoorbaan, Serversteer etc"
          />
        </div>

        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary"
            >Hoeveel uur werk je per week?</span
          >
          <v-text-field
            v-model="localQuestions['Hoeveel uur werk je per week?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
            type="number"
            hide-spin-buttons
          >
            <template v-slot:append-inner>
              <span class="text-normal text-secondary">uur</span>
            </template>
          </v-text-field>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Hoe actief ben jij tijdens jouw werk?</span
          >
          <v-select
            :rules="[rules.select_rules.required]"
            v-model="localQuestions['Hoe actief ben jij tijdens jouw werk?']"
            class="vragenlijst-v-select"
            :items="workoptions"
            color="secondary"
            base-color="secondary"
            placeholder="Hoe actief ben jij tijdens jouw werk?"
            variant="underlined"
          />
          <!-- <v-card flat class="rounded-12">
            <v-list class="pa-2" lines="one">
              <v-list-item v-for="option in workoptions" :key="option" :subtitle="option" :class="localQuestions['Hoe actief ben jij tijdens jouw werk?'] ==
                option
                ? 'list-item-selected'
                : ''
                " @click="
                  localQuestions['Hoe actief ben jij tijdens jouw werk?'] =
                  option
                  "></v-list-item>
            </v-list>
          </v-card> -->
          <v-slide-y-transition>
            <span
              v-if="list_error"
              class="text-secondary text-extra-small vragenlijst-error"
              >{{ list_error }}</span
            >
          </v-slide-y-transition>
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  computed: {
    list_error() {
      if (
        this.localQuestions["Hoe actief ben jij tijdens jouw werk?"] == null &&
        this.continue == true
      ) {
        return "Dit veld is verplicht";
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      rules: FormRules.rules,
      localQuestions: { ...this.questions },

      selectedWorkOption: null,

      workoptions: [
        "Ik zit het grootste gedeelte van de dag",
        "Ik ben regelmatig in beweging",
        "Ik ben de hele dag in beweging",
      ],

      category: null,
      categories: [
        "Fit voor drukke moeders",
        "Zwanger & weer in shape",
        "Fresh start (18-25)",
        "Fit & fabulous (26-50)",
        "Stronger you (50+)",
        "Forever fit (60+)",
        "Fit en energiek voor mannen",
      ],

      // list_error: true,
      error: "",
      continue: false,
    };
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
  mounted() {
    if (this.$refs.form3) {
      // Add watcher for isValidating property of v-form
      this.$watch(
        () => this.$refs.form3?.isValidating,
        () => {
          this.continue = true;
        }
      );
    }
  },
  methods: {
    nextStep() {
      this.$emit("nextStep", this.geslacht);
    },
  },
};
</script>
<style></style>
